module.exports = __WEBPACK_EXTERNAL_MODULE_77__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx"],"commonjs":"rxjs/Subject","commonjs2":"rxjs/Subject","amd":"rxjs/Subject"}
// module id = 77
// module chunks = 0